import { API_BASE_URL } from "configs/AppConfig";
import {isImmutable} from "immutable";
import { AUTH_REFRESH_TOKEN, AUTH_TOKEN } from "redux/constants/Auth";

/**
 * Download method
 * @param url
 * @returns {Promise<R>}
 */
 const download = (url, options = {}, method = 'GET') => {
    return new Promise((resolve, reject) => {
            let baseURL = API_BASE_URL + url;
            fetch(baseURL, {
                ...options,
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem(AUTH_TOKEN) ? `Bearer ${localStorage.getItem(AUTH_TOKEN)}` : undefined,
                }
            })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                a.target = '_blank';
                // the filename you want
                //a.download = "todo-1.json";
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                // alert("your file has downloaded!"); // or you know, something with better UX...
            })
            .catch((error) => {
                console.log(error);
                reject(new Error(error));
            });            
        },
    );

};

/**
 * Get method
 * @param url
 * @returns {Promise<R>}
 */
const get = (url, options = {}, method = 'GET') => {
    return new Promise((resolve, reject) => {
            let baseURL = API_BASE_URL + url;
            fetch(baseURL, {
                ...options,
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem(AUTH_TOKEN) ? `Bearer ${localStorage.getItem(AUTH_TOKEN)}` : undefined,
                }
            })
            .then(res => {
                return res.json()
            })
            .then(data => {
                resolve(data);
            })
            .catch((error) => {
                console.log(error);
                reject(new Error(error));
            });
        },
    );

};

/**
 * Post method
 * @param url
 * @param data
 * @returns {Promise<R>}
 */
const post = (url, data, method = 'POST', type = 'default') => {
    return new Promise((resolve, reject) => {

        // To JS Object
        if (isImmutable(data)) {
            data = data.toJS();
        }

        let baseURL = API_BASE_URL + url;
        let authorization = "";
        if (type === 'default') authorization = `Bearer ${localStorage.getItem(AUTH_TOKEN)}`
        else authorization = `Bearer ${localStorage.getItem(AUTH_REFRESH_TOKEN)}`
        
        fetch(baseURL, {
            method: method,
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem(AUTH_TOKEN) ? authorization : undefined,
            }
        })
        .then(res => {
            if (method === 'POST') return res.json()
            else return res
        })
        .then(data => {
            resolve(data);
        })
        .catch((error) => {
            reject(error);
        });
    });

};

export default {
    download,
    get,
    post,
    put: (url, data) => post(url, data, 'PUT'),
    delete: (url, data) => post(url, data, 'DELETE'),
};

